import withParams from "@src/components/widgets/HOC/withParams";
import React from "react";
import { WidgetTemplateComponentType } from "@src/interface/Widget";
import { ILandingStandardWidgetAboutWithFooterPetitPrinceParams } from "../interface";
import LandingAboutWithFooterPetitPrince from "design-system/src/Components/WidgetPart/LandingAboutWithFooterPetitPrince/LandingAboutWithFooterPetitPrince";

const AboutWithFooterPetitPrince: WidgetTemplateComponentType =
  withParams<ILandingStandardWidgetAboutWithFooterPetitPrinceParams>(
    (props) => {
      const { p } = props;

      return (
        <LandingAboutWithFooterPetitPrince
          aboutProps={{
            description: p("description"),
          }}
          footerProps={{
            socialNetworkLabel: p("social_text"),
            socialLinks: {
              facebook: p("facebook_link"),
              instagram: p("instagram_link"),
              pinterest: p("pinterest_link"),
              tiktok: p("tiktok_link"),
            },
            footerText: p("footer_text"),
          }}
        />
      );
    }
  );

export default AboutWithFooterPetitPrince;
